import { QuestionAnswer as FAQIcon } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { PageShell } from "@/components/common/PageShell";

function FAQ() {
  const [openItem, setOpenItem] = useState<string | null>(null);
  const { t } = useTranslation();

  const faqData = {
    dashboard: [
      {
        question: t("help.faq.dashboard.addManagersOrAssociates.question"),
        answer: t("help.faq.dashboard.addManagersOrAssociates.answer"),
      },
      {
        question: t("help.faq.dashboard.editOrRemoveUsers.question"),
        answer: t("help.faq.dashboard.editOrRemoveUsers.answer"),
      },
      {
        question: t("help.faq.dashboard.changePassword.question"),
        answer: t("help.faq.dashboard.changePassword.answer"),
      },
      {
        question: t("help.faq.dashboard.shareFeedback.question"),
        answer: t("help.faq.dashboard.shareFeedback.answer"),
      },
      {
        question: t("help.faq.dashboard.changeStoresOrLocations.question"),
        answer: t("help.faq.dashboard.changeStoresOrLocations.answer"),
      },
    ],
    shopper: [
      {
        question: t("help.faq.shopper.howRfidWorks.question"),
        answer: t("help.faq.shopper.howRfidWorks.answer"),
      },
      {
        question: t("help.faq.shopper.howBarcodeScannerWorks.question"),
        answer: t("help.faq.shopper.howBarcodeScannerWorks.answer"),
      },
      {
        question: t("help.faq.shopper.fittingRoomScreenNotUpdating.question"),
        answer: t("help.faq.shopper.fittingRoomScreenNotUpdating.answer"),
      },
      {
        question: t("help.faq.shopper.photosNotAppearing.question"),
        answer: t("help.faq.shopper.photosNotAppearing.answer"),
      },
      {
        question: t("help.faq.shopper.inventoryAvailabilityMismatch.question"),
        answer: t("help.faq.shopper.inventoryAvailabilityMismatch.answer"),
      },
      {
        question: t("help.faq.shopper.cameraInFittingRoom.question"),
        answer: t("help.faq.shopper.cameraInFittingRoom.answer"),
      },
      {
        question: t("help.faq.shopper.shopperDoesNotExitApp.question"),
        answer: t("help.faq.shopper.shopperDoesNotExitApp.answer"),
      },
      {
        question: t("help.faq.shopper.cannotLogin.question"),
        answer: t("help.faq.shopper.cannotLogin.answer"),
      },
      {
        question: t("help.faq.shopper.handheldDeviceCannotScan.question"),
        answer: t("help.faq.shopper.handheldDeviceCannotScan.answer"),
      },
    ],
    hardware: [
      {
        question: t("help.faq.hardware.removeDevicesFromEnclosures.question"),
        answer: t("help.faq.hardware.removeDevicesFromEnclosures.answer"),
      },
      {
        question: t("help.faq.hardware.fittingRoomScreenNotResponding.question"),
        answer: t("help.faq.hardware.fittingRoomScreenNotResponding.answer"),
      },
      {
        question: t("help.faq.hardware.handheldDevicesLosingPower.question"),
        answer: t("help.faq.hardware.handheldDevicesLosingPower.answer"),
      },
      {
        question: t("help.faq.hardware.checkAppVersion.question"),
        answer: t("help.faq.hardware.checkAppVersion.answer"),
      },
      {
        question: t("help.faq.hardware.registerDevicePrompt.question"),
        answer: t("help.faq.hardware.registerDevicePrompt.answer"),
      },
    ],
  };

  return (
    <PageShell title={t("help.faq.title")} gradientTitle icon={<FAQIcon />} bodySx={{ pb: 4 }}>
      <div className="pt-0 space-y-8">
        <div>
          <h3 className="text-xl font-semibold text-gray-900 mb-4">
            {t("help.faq.sections.dashboardManagement")}
          </h3>
          {faqData.dashboard.map((item, index) => (
            <div key={`dashboard-${index}`} className="mb-2">
              <button
                className={`w-full p-4 flex justify-between items-center bg-white border border-gray-200 rounded-t-lg transition-all duration-200 
                  ${
                    openItem === `dashboard-${index}`
                      ? "bg-gray-50 rounded-b-none border-b-0"
                      : "rounded-lg hover:bg-gray-50"
                  }`}
                onClick={() =>
                  setOpenItem(openItem === `dashboard-${index}` ? null : `dashboard-${index}`)
                }
              >
                <div className="text-left rtl:text-right text-gray-900">{item.question}</div>
                <KeyboardArrowDownIcon
                  className={`text-gray-500 transition-transform duration-200 ${openItem === `dashboard-${index}` ? "rotate-180" : ""}`}
                />
              </button>
              {openItem === `dashboard-${index}` && (
                <div className="p-4 bg-white border border-gray-200 rounded-b-lg text-gray-600 leading-relaxed">
                  {item.answer}
                </div>
              )}
            </div>
          ))}

          <h3 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
            {t("help.faq.sections.shopperExperience")}
          </h3>
          {faqData.shopper.map((item, index) => (
            <div key={`shopper-${index}`} className="mb-2">
              <button
                className={`w-full p-4 flex justify-between items-center bg-white border border-gray-200 rounded-t-lg transition-all duration-200 
                  ${
                    openItem === `shopper-${index}`
                      ? "bg-gray-50 rounded-b-none border-b-0"
                      : "rounded-lg hover:bg-gray-50"
                  }`}
                onClick={() =>
                  setOpenItem(openItem === `shopper-${index}` ? null : `shopper-${index}`)
                }
              >
                <div className="text-left rtl:text-right text-gray-900">{item.question}</div>
                <KeyboardArrowDownIcon
                  className={`text-gray-500 transition-transform duration-200 ${openItem === `shopper-${index}` ? "rotate-180" : ""}`}
                />
              </button>
              {openItem === `shopper-${index}` && (
                <div className="p-4 bg-white border border-gray-200 rounded-b-lg text-gray-600 leading-relaxed">
                  {item.answer}
                </div>
              )}
            </div>
          ))}

          <h3 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
            {t("help.faq.sections.hardware")}
          </h3>
          {faqData.hardware.map((item, index) => (
            <div key={`hardware-${index}`} className="mb-2">
              <button
                className={`w-full p-4 flex justify-between items-center bg-white border border-gray-200 rounded-t-lg transition-all duration-200 
                  ${
                    openItem === `hardware-${index}`
                      ? "bg-gray-50 rounded-b-none border-b-0"
                      : "rounded-lg hover:bg-gray-50"
                  }`}
                onClick={() =>
                  setOpenItem(openItem === `hardware-${index}` ? null : `hardware-${index}`)
                }
              >
                <div className="text-left rtl:text-right text-gray-900">{item.question}</div>
                <KeyboardArrowDownIcon
                  className={`text-gray-500 transition-transform duration-200 ${openItem === `hardware-${index}` ? "rotate-180" : ""}`}
                />
              </button>
              {openItem === `hardware-${index}` && (
                <div className="p-4 bg-white border border-gray-200 rounded-b-lg text-gray-600 leading-relaxed">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}

export default FAQ;
